// extracted by mini-css-extract-plugin
export default {"form":"form__tgjyDkpqZBGa52mimsly","title":"title__qIXO1x5wmMp1_ZZtoEej","greenError":"greenError__rJqfmmDgG4ERvb5T44bv"};